import React from "react";
import Translation from "./components/Translation";
import "./styles.css";

function App() {
  return (
    <div className="app">
      <Translation />
    </div>
  );
}

export default App;
